
/* injects from baggage-loader */

import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {deleteReport} from 'redux/modules/reports/actions'
import Confirm from 'components/Confirm'

export default connect((state, {report}) => {
  return {
    message: `Do you really want to delete "${report.name}"?`,
    ok: 'Delete'
  }
}, (dispatch, {report}) => {
  const dispatchCloseModal = () => dispatch(closeModal())

  return {
    onOk: () => dispatch(deleteReport(report.id)).success(dispatchCloseModal).fail(dispatchCloseModal),
    onCancel: dispatchCloseModal
  }
})(Confirm)



// WEBPACK FOOTER //
// ./client/modals/ReportDeleteConfirm/index.js